export default __webpack_public_path__ + "static/media/PES.1fbfe4cf.png";